import { BKJLoadingSpinner, ErrorBoundary } from '@awais4123/fillify-design-library';
import { BKJCenteredDialog } from 'components/BKJCenteredDialog';
import { BKJSideModal } from 'components/BKJSideModal';
import { GroupsDetailsComponentMap } from 'pages/SettingsPage/modals/GroupsModal/GroupsModal.constants';
import {
  GroupsModalDataContext,
  useGroupsModalDataContext,
} from 'pages/SettingsPage/modals/GroupsModal/GroupsModal.data.context';
import {
  GroupsModalFormProvider,
  useGroupsModalFormContext,
} from 'pages/SettingsPage/modals/GroupsModal/GroupsModal.form.context';
import { FormWrapper } from 'pages/SettingsPage/modals/GroupsModal/GroupsModal.styled';
import {
  groupsModalRoutingService,
  useGroupsDetailsModalUIContext,
} from 'pages/SettingsPage/modals/GroupsModal/GroupsModal.ui.context';
import { QuerySwitch } from 'components/QuerySwitch';
import { FC, FormEventHandler, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WhiteLabelAccessor } from 'utils/whiteLabelAccessor';

const EditableViews = [
  'AddMembers',
  'EditGroup',
  'EditMembers',
  'NewGroup',
  'SelectCriteria',
  'EditCriteria',
];
const QuerySwitchViews = [
  'EditGroup',
  'EditCriteria',
  'ViewStaticGroup',
  'ViewDynamicGroup',
  'EditMembers',
];

export const GroupsModalViewComponent: FC = () => {
  const { groupId, isOpen, groupsActiveModalView } = useGroupsDetailsModalUIContext();
  const { onSubmit } = useGroupsModalFormContext();
  const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false);

  const Component = GroupsDetailsComponentMap[groupsActiveModalView];

  const { t } = useTranslation();

  const modalHeader = {
    NewGroup: t('groups:NEW_GROUP'),
    AddMembers: t('groups:NEW_GROUP'),
    SelectCriteria: t('groups:NEW_GROUP'),
    EditCriteria: t('groups:EDIT_GROUP'),
    EditGroup: t('groups:EDIT_GROUP'),
    EditMembers: t('groups:EDIT_GROUP'),
    ViewStaticGroup: t('groups:GROUP_DETAILS'),
    ViewDynamicGroup: t('groups:GROUP_DETAILS'),
  };
  const { hasNextPage } = useGroupsModalDataContext();

  return (
    <BKJSideModal
      isOpen={isOpen}
      onClose={() => {
        // Use confirmation dialog if it's an editable viewe
        if (EditableViews.includes(groupsActiveModalView)) {
          setIsConfirmDeleteOpen(true);
        } else groupsModalRoutingService.close();
      }}
      showBackButton={groupsModalRoutingService.isBackButtonVisible()}
      onBack={groupsModalRoutingService.goToPrevView}
      headerComponent={modalHeader[groupsActiveModalView]}
    >
      <ErrorBoundary componentName="GroupsModal" showLogo={!WhiteLabelAccessor.isWhiteLabelled()}>
        {groupId && hasNextPage ? (
          <BKJLoadingSpinner variant="Default" />
        ) : (
          <GroupsModalFormProvider>
            <FormWrapper onSubmit={onSubmit as unknown as FormEventHandler<HTMLFormElement>}>
              <BKJCenteredDialog
                isOpen={isConfirmDeleteOpen && isOpen}
                variant="Danger"
                title={t('groups:DISCARD_CHANGES')}
                text={''}
                cancelLabel={t('groups:CANCEL')}
                actionLabel={t('groups:DISCARD')}
                onAction={() => {
                  setIsConfirmDeleteOpen(false);
                  groupsModalRoutingService.close();
                }}
                onCancel={() => setIsConfirmDeleteOpen(false)}
                onClose={() => setIsConfirmDeleteOpen(false)}
              />
              {isOpen && <Component />}
            </FormWrapper>
          </GroupsModalFormProvider>
        )}
      </ErrorBoundary>
    </BKJSideModal>
  );
};

export const GroupsModalComponent: FC = () => {
  const { groupsActiveModalView } = useGroupsDetailsModalUIContext();
  if (QuerySwitchViews.includes(groupsActiveModalView)) {
    return <QuerySwitch context={GroupsModalDataContext} component={GroupsModalViewComponent} />;
  }
  return <GroupsModalViewComponent />;
};
